import React, { useState } from 'react';
import { Input, Button } from 'antd';
import {
  LockOutlined,
  ArrowRightOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import './CustomPDFViewer.scss';

interface Props {
  onSubmit: (password: string) => void;
  error?: string;
  setError?: (val: string) => void;
}

const PasswordGate: React.FC<Props> = ({ onSubmit, error, setError }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = () => {
    if (!password.trim()) {
      setError?.('Please enter password');
      return;
    }
    onSubmit(password);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (error) setError?.('');
  };

  return (
    <div className="password-gate">
      <LockOutlined className="lock-icon" />

      <h2 className="title">Password Required</h2>

      <div className="input-wrapper">
        <div className={`input-container ${error ? 'error' : ''}`}>
          <Input
            value={password}
            onChange={handleChange}
            placeholder="Enter password"
            onPressEnter={handleSubmit}
            bordered={false}
          />

          {error && (
            <CloseOutlined
              className="clear-icon"
              onClick={() => {
                setPassword('');
                setError?.('');
              }}
            />
          )}
        </div>

        <Button
          className="submit-btn"
          icon={<ArrowRightOutlined />}
          onClick={handleSubmit}
        />
      </div>

      {error && <div className="error-text">{error}</div>}
    </div>
  );
};

export default PasswordGate;
